/**
 * Global application configuration.
 * This file serves as a centralized place to store constant values
 * used throughout the application, such as the app name and version.
 */
import packageJson from '../package.json';

/**
 * Type definition for the application configuration object.
 */
export type ConfigValue = {
  appName: string;
  appVersion: string;
};

/**
 * The global configuration object.
 * appVersion is automatically pulled from the root package.json.
 */
export const CONFIG: ConfigValue = {
  appName: 'Coruscant Bank',
  appVersion: packageJson.version,
};
